import { render, staticRenderFns } from "./WineEdit_Desktop.vue?vue&type=template&id=2118ec35&scoped=true&"
import script from "./WineEdit_Desktop.vue?vue&type=script&lang=js&"
export * from "./WineEdit_Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118ec35",
  null
  
)

export default component.exports